// Task 24467 - staff contact points and their customisable labels.
// Kept as its own slice rather than added to store/staff, which is already
// ~2000 lines across action/reducer/saga.

export const STAFF_CONTACT_TYPE_LIST = "STAFF_CONTACT_TYPE_LIST";
export const STAFF_CONTACT_TYPE_LIST_SUCCESS = "STAFF_CONTACT_TYPE_LIST_SUCCESS";
export const STAFF_CONTACT_TYPE_LIST_FAILURE = "STAFF_CONTACT_TYPE_LIST_FAILURE";

export const STAFF_CONTACT_TYPE_CREATE = "STAFF_CONTACT_TYPE_CREATE";
export const STAFF_CONTACT_TYPE_CREATE_SUCCESS = "STAFF_CONTACT_TYPE_CREATE_SUCCESS";
export const STAFF_CONTACT_TYPE_CREATE_FAILURE = "STAFF_CONTACT_TYPE_CREATE_FAILURE";

export const STAFF_CONTACT_TYPE_UPDATE = "STAFF_CONTACT_TYPE_UPDATE";
export const STAFF_CONTACT_TYPE_UPDATE_SUCCESS = "STAFF_CONTACT_TYPE_UPDATE_SUCCESS";
export const STAFF_CONTACT_TYPE_UPDATE_FAILURE = "STAFF_CONTACT_TYPE_UPDATE_FAILURE";

export const STAFF_CONTACT_TYPE_DELETE = "STAFF_CONTACT_TYPE_DELETE";
export const STAFF_CONTACT_TYPE_DELETE_SUCCESS = "STAFF_CONTACT_TYPE_DELETE_SUCCESS";
export const STAFF_CONTACT_TYPE_DELETE_FAILURE = "STAFF_CONTACT_TYPE_DELETE_FAILURE";

export const STAFF_CONTACT_LIST = "STAFF_CONTACT_LIST";
export const STAFF_CONTACT_LIST_SUCCESS = "STAFF_CONTACT_LIST_SUCCESS";
export const STAFF_CONTACT_LIST_FAILURE = "STAFF_CONTACT_LIST_FAILURE";

export const STAFF_CONTACT_CREATE = "STAFF_CONTACT_CREATE";
export const STAFF_CONTACT_CREATE_SUCCESS = "STAFF_CONTACT_CREATE_SUCCESS";
export const STAFF_CONTACT_CREATE_FAILURE = "STAFF_CONTACT_CREATE_FAILURE";

export const STAFF_CONTACT_UPDATE = "STAFF_CONTACT_UPDATE";
export const STAFF_CONTACT_UPDATE_SUCCESS = "STAFF_CONTACT_UPDATE_SUCCESS";
export const STAFF_CONTACT_UPDATE_FAILURE = "STAFF_CONTACT_UPDATE_FAILURE";

export const STAFF_CONTACT_DELETE = "STAFF_CONTACT_DELETE";
export const STAFF_CONTACT_DELETE_SUCCESS = "STAFF_CONTACT_DELETE_SUCCESS";
export const STAFF_CONTACT_DELETE_FAILURE = "STAFF_CONTACT_DELETE_FAILURE";
